exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.warning-tip[data-v-407292b6] {\n  background-color: #fff8f0;\n  border: 1px solid #faecd8;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.warning-tip i[data-v-407292b6] {\n  color: #e6a23c;\n  font-size: 16px;\n  margin-right: 8px;\n}\n.warning-tip span[data-v-407292b6] {\n  color: #606266;\n  font-size: 14px;\n}\n", ""]);

// exports
